import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sizeConverson'
})
export class SizeConversonPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let fSize = 0;
    var fSExt = new Array('Bytes', 'KB', 'MB', 'GB');
    fSize = value;
    let i = 0;
    while (fSize > 1023) {
      fSize /= 1024; i++;
    }
    return (Math.round(fSize * 100) / 100) + ' ' + fSExt[i]
  }
}
